import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import data from "../../assets/apiRoutes.json";
import TextBox from 'devextreme-react/text-box';
import { Button } from "devextreme-react";
import notify from 'devextreme/ui/notify';
import Validator, { RequiredRule, CustomRule ,CompareRule} from 'devextreme-react/validator';

const ChangePassword = (props) => {
  const [openChangePwdResponseDialog, setOpenChangePwdResponseDialog] = useState(false);
  const [changePasswordRequest, setChangePasswordRequest] = useState({
    userId: props.oidc.user.profile.sub,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const onInputChange = (e, name) => {
    let value = e.value;
    if(value==="")
      return;
    setChangePasswordRequest({
      ...changePasswordRequest,
      [name]: value,
    });
  };

  const changePasswordCallback = () => {
    axios
      .post(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.ChangePassword}`,
        changePasswordRequest
      ).then(res => {
        console.log(res, "change password response");
        if (res.data === true) {
          setOpenChangePwdResponseDialog(true);
          setChangePasswordRequest({
            oldPassword:"",
            newPassword:"",
            confirmPassword:""
          })
          notify(
            {
                message: 'Password has been updated successfully.',
                width: 100,
            },
            'success',
            3000,
        );
        }
        else {
          notify(
            {
                message: 'Password change was unsuccessful.',
                width: 100,
            },
            'error',
            3000,
        ); 
        }
      }).catch(err => {
        console.log(err, 'err in request')
      })
  }
  const changePassword = (e) => {
    e.preventDefault();
    changePasswordCallback();
  };
  return (
    <>
      <div>

        <div className="update-wrapper ">
          <div className="changePassword-container dx-card ">
            <h6 className="title" style={{ marginLeft: "10px",marginTop:"12px",color:window._env_.Color2 }}>Change Password</h6>
            <form className="resetPwd-form" style={{ margin: "5px 32px" }} onSubmit={(e) => changePassword(e)}>
              <div className="accordianLastRow col-md-3">
                <TextBox
                  id="oldPassword"
                  name="oldPassword"
                  label="Enter Old Password"
                  labelMode="static"
                  stylingMode='outlined'
                  mode = "Password"
                  value={changePasswordRequest.oldPassword}
                  onValueChanged={(e) => onInputChange(e, 'oldPassword')}
                  >
                  {<Validator><RequiredRule message={`Old Password is required`} /></Validator>}
                  </TextBox>
              </div>
              <div className="accordianLastRow col-md-3">

                <TextBox
                  id="newPassword"
                  name="newPassword"
                  label="Enter New Password"
                  labelMode="static"
                  stylingMode='outlined'
                  mode="Password"
                  value={changePasswordRequest.newPassword}
                  onValueChanged={(e) => onInputChange(e, 'newPassword')}
                >
                  {<Validator><RequiredRule message={`New Password is required`} /></Validator>}
                </TextBox>
              </div>

              <div className="accordianLastRow col-md-3">

                <TextBox
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Enter Confirm Password"
                  labelMode="static"
                  stylingMode='outlined'
                  mode = "Password"
                  value={changePasswordRequest.confirmPassword}
                  onValueChanged={(e) => onInputChange(e, 'confirmPassword')}
                >
                {<Validator><RequiredRule message={`Confirm Password is required`} />
                <CompareRule 
              comparisonTarget={() => changePasswordRequest.newPassword} 
              message="Passwords do not match." 
            />
            </Validator>}
                </TextBox>
              </div>
              <div className="col-md-3">
                <Button
                  style={{ marginTop: "10px" }}
                  useSubmitBehavior={true}
                  type="default"
                  text="Save"
                />
                <Button
                  style={{ marginTop: "10px", marginLeft: "12px" }}
                  onClick={() => {
                    setChangePasswordRequest({
                      userId: props.oidc.user.profile.sub,
                      oldPassword: "",
                      newPassword: "",
                      confirmPassword: "",
                    });
                  }}
                  text="Reset"
                />

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ChangePassword);
